import React, { PureComponent } from 'react';
import styled, { keyframes } from 'styled-components';

const ACCENT = '#FF8C00';
const TRACK_LIGHT = '#E2E8F0';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const SVGRoot = styled.svg`
  display: block;
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '100%'};
  padding: ${(props) => props.padding || '0'};
  margin: ${(props) => props.margin || '0'};
  flex-shrink: 0;
`;

const SpinArc = styled.g`
  transform-origin: 50px 50px;
  animation: ${rotate} 0.75s linear infinite;
`;

const R = 40;
const STROKE = 7;
const CIRC = 2 * Math.PI * R;
const DASH_VISIBLE = CIRC * 0.25;

export default class LoadingCircle extends PureComponent {
  trackColor() {
    const { color } = this.props;
    if (color === false || color === 'color_white') {
      return 'rgba(255, 255, 255, 0.42)';
    }
    return TRACK_LIGHT;
  }

  accentColor() {
    const { accentColor } = this.props;
    return accentColor || ACCENT;
  }

  render() {
    const {
      width,
      height,
      padding,
      margin,
      trackColor,
      className,
      style
    } = this.props;
    const track = trackColor || this.trackColor();
    const accent = this.accentColor();

    return (
      <SVGRoot
        width={width}
        height={height}
        padding={padding}
        margin={margin}
        className={className}
        style={style}
        viewBox="0 0 100 100"
        aria-hidden="true"
      >
        <circle
          cx="50"
          cy="50"
          r={R}
          fill="none"
          stroke={track}
          strokeWidth={STROKE}
          strokeLinecap="butt"
        />
        <SpinArc>
          <circle
            cx="50"
            cy="50"
            r={R}
            fill="none"
            stroke={accent}
            strokeWidth={STROKE}
            strokeLinecap="butt"
            strokeDasharray={`${DASH_VISIBLE} ${CIRC}`}
          />
        </SpinArc>
      </SVGRoot>
    );
  }
}
